import { render, staticRenderFns } from "./AdminTopHeader.vue?vue&type=template&id=ab98a79e"
import script from "./AdminTopHeader.vue?vue&type=script&lang=js"
export * from "./AdminTopHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports